import React, { Component } from "react";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import moment from "moment";
import { Calendar, momentLocalizer } from "react-big-calendar";
import { ModalFooter, Modal, ModalHeader, ModalBody } from "reactstrap";
import { Channels } from "./Channels";
import { SLACalendarToolbar } from "./SLACalendarToolbar";
import { Platforms } from "./Platforms";
import "./Settings.css";

class Settings extends Component {
  state = {
    calendarModal: false,
    calendarEvents: [],
    calendarDefaultDate: new Date(),
    calendarTitle: "",
  };

  toggleCalendarModal = () => {
    this.setState({
      calendarModal: !this.state.calendarModal,
    });
  };

  generateSlaCalendarsGrid = (slaCalenders) => {
    const { translate } = this.props;
    return (
      <table className="table" style={{ display: "table" }}>
        <thead>
          <tr>
            <th />
            <th>{translate("Country")}</th>
            <th>{translate("Year")}</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {(slaCalenders || []).map((item) => (
            <tr key={item._id}>
              <td style={{ width: "40px", textAlign: "center" }}>
                <div
                  className={`ca-circle ${this.getCaCircleColor(
                    item.startdate
                  )}`}
                />
              </td>
              <td>{this.getCountry(item.countrycode)}</td>
              <td>{this.getYear(item.startdate)}</td>
              <td>
                <button
                  style={{ padding: "0 5px" }}
                  className="add-issue-btn"
                  onClick={() => this.showCalender(item)}
                >
                  <i className="fa fa-eye" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  showCalender = async (item) => {
    const calendarStart = moment.utc(item.startdate, moment.ISO_8601).toDate();
    const calendarEnd = moment.utc(item.enddate, moment.ISO_8601).toDate();
    this.setState({
      calendarModal: true,
      calendarEvents: this.getEvents(item),
      calendarDefaultDate: calendarStart,
      calendarTitle: `${this.getCountry(item.countrycode)} ${this.getYear(
        item.startdate
      )}`,
      calendarStart,
      calendarEnd,
    });
  };

  getEvents = (data) => {
    const events = [];
    const _dataDetails = data.data || [];
    _dataDetails.forEach((item, index) => {
      const _start = moment.utc(item.date, moment.ISO_8601).toDate();
      const _end = moment.utc(item.date, moment.ISO_8601).toDate();
      events.push({
        id: index,
        title: item.datetype,
        start: _start,
        end: _end,
      });
    });
    return events;
  };

  getCountry = (countrycode) => {
    const countries = {
      NO: "Norway",
      SE: "Sweden",
      FI: "Finland",
    };
    return countries[countrycode] || countrycode;
  };

  getYear = (date) => {
    return date ? moment(date, moment.ISO_8601).format("YYYY") : "n/a";
  };

  getCaCircleColor = (date) => {
    const _year = parseInt(this.getYear(date));
    const _currentYear = new Date().getFullYear();
    return _year > _currentYear ? "grey" : "green";
  };

  eventStyleGetter = (date) => {
    const { calendarEvents } = this.state;
    const _holidayItem = calendarEvents.filter(
      (ev) => ev.start.getTime() === date.getTime() && ev.title === "holiday"
    )[0];
    if (_holidayItem) {
      return { style: { backgroundColor: "#ffc90e" } };
    }
  };

  /* isWeekEnd = (date) => {
    var dayOfWeek = date.getDay();
    return dayOfWeek === 6 || dayOfWeek === 0;
  }; */

  render() {
    const { slaCalenders, translate } = this.props;
    const { calendarDefaultDate, calendarStart, calendarEnd } = this.state;
    const localizer = momentLocalizer(moment);
    return (
      <div className="settings-main row">
        <div
          className="setting-container"
          style={{ padding: "1em", marginTop: "3em" }}
        >
          <div className="row">
            <div className="col-sm-4" style={{ padding: 0 }}>
              <Channels />
            </div>
            <div className="col-sm-6" style={{ padding: 0 }}>
              <Platforms />
            </div>
            <div className="col-sm-2" style={{ padding: 0 }}>
              <div className="channel-container">
                <strong>{translate("SLACalendars")}</strong>
                <div className="channel-grid">
                  {this.generateSlaCalendarsGrid(slaCalenders)}
                </div>
              </div>
            </div>
          </div>
        </div>
        {!!this.state.calendarModal && (
          <Modal
            isOpen={this.state.calendarModal}
            toggle={this.toggleCalendarModal}
            style={{ maxWidth: "800px", maxHeight: "800px" }}
          >
            <ModalHeader toggle={this.toggleCalendarModal}>
              Calendar: {this.state.calendarTitle}
            </ModalHeader>
            <ModalBody>
              <Calendar
                localizer={localizer}
                events={[]}
                views={{ month: true }}
                startAccessor="start"
                endAccessor="end"
                min={calendarStart}
                max={calendarEnd}
                defaultDate={calendarDefaultDate}
                dayPropGetter={this.eventStyleGetter}
                style={{ height: 500 }}
                components={{
                  toolbar: (props) => (
                    <SLACalendarToolbar
                      min={calendarStart}
                      max={calendarEnd}
                      {...props}
                    />
                  ),
                }}
              />
            </ModalBody>
            <ModalFooter className="text-center">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={this.toggleCalendarModal}
              >
                Close
              </button>
            </ModalFooter>
          </Modal>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    settings: { slaCalenders },
    locale,
  } = state;
  return {
    slaCalenders,
    translate: getTranslate(locale),
  };
}

const connectedSettings = connect(mapStateToProps)(Settings);
export { connectedSettings as Settings };
